import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import "../styles/filter.scss";
import { useState } from "react";
import AppInput from "../common/AppInput";

export default function useTableFilter(
  { type, data = [], headerName },
  callback,
  isFilter
) {
  const DPicker = () => {
    const [open, setOpen] = useState(true);

    return (
      <div className="date-filter" style={{ backgroundColor: "transparent" }}>
        <DatePicker
          showPopperArrow={true}
          onChange={(date) => {
            setOpen(false);
            const dt = data.filter((i) => {
              const d = i[headerName].split("/");
              const d1 = `${d[2]}-${d[1]}-${d[0]}`;
              const d2 = `${d[2]}-${d[0]}-${d[1]}`;
              const dx = new Date(new Date(d1 || d2).setHours(0, 0, 0));
              return dx.toDateString() === date.toDateString();
            });
            callback && callback(dt);
            isFilter(false);
          }}
          open={open}
          onClickOutside={() => {
            setOpen(false);
          }}
          customInput={<div style={{ position: "absolute" }}></div>}
        />
      </div>
    );
  };
  const Select = () => {
    const dt = _.uniq(data.map((i) => i[headerName]));
    return (
      <div className="filter" style={{ backgroundColor: "transparent" }}>
        <ul className="list-group" style={{ zIndex: 5000 }}>
          {dt.map((item) => (
            <li
              onClick={() => {
                const dt = data.filter(
                  (i) => i[headerName].indexOf(item) !== -1
                );
                callback && callback(dt);
                isFilter(false);
              }}
              key={item}
              className="list-group-item list-group-item-action"
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
    );
  };
  const Searchbar = () => {
    return (
      <div
        className="filter"
        style={{
          marginTop: -60,
          backgroundColor: "transparent",
          position: "absolute",
          left: 0,
        }}
      >
        <AppInput
          autoFocus
          onBlur={() => isFilter(false)}
          onChange={(e) => {
            const word = e.target.value;
            const dt = data.filter(
              (i) =>
                i[headerName].toLowerCase().indexOf(word.toLowerCase()) !== -1
            );
            callback && callback(dt);
          }}
          placeholder="Search Filter..."
        />
      </div>
    );
  };

  if (type === "DatePicker") return DPicker;
  else if (type === "Select") return Select;
  else if (type === "Search") return Searchbar;
}
